export default __webpack_public_path__ + "static/media/client15.62d38ed4.png";